import React, { Fragment, useEffect } from 'react';
import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import PartnerSection from '../../components/PartnerSection';
import StatsBand from '../../components/StatsBand/StatsBand';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import WorkProcess from '../../components/WorkProcess/WorkProcess';
import IndustrieSection from '../../components/IndustrieSection/IndustrieSection';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import CtaSection from '../../components/CtaSection/CtaSection';
import FaqSection from '../../components/FaqSection/FaqSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import StructuredData from '../../components/common/StructuredData';
import '../../css/home-elegant.css';


const PAGE_TITLE = 'Bogin Tech | Custom Software Development, AI, Cloud & Mobile App Company';
const PAGE_DESCRIPTION = 'Bogin Tech builds enterprise web apps, mobile apps, AI/ML automation, cloud platforms & blockchain solutions. Trusted by 500+ companies. MVP to production in 90 days.';

const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
};

const HomePage = () => {

    useEffect(() => {
        const previousTitle = document.title;
        document.title = PAGE_TITLE;
        setMeta('description', PAGE_DESCRIPTION);
        setMeta('keywords', 'custom software development, enterprise software, AI ML integration, mobile app development, cloud solutions, blockchain development, DevOps, IoT, Bogin Tech');
        return () => {
            document.title = previousTitle;
        };
    }, []);

    return (
        <Fragment>
            <StructuredData />
            <div className='body_wrap sco_agency'>
                <Header />
                <main className="page_content">
                    <Hero />
                    <PartnerSection />
                    <StatsBand />
                    <About />
                    <ServiceSection />
                    <ProjectSection />
                    <WorkProcess />
                    <IndustrieSection />
                    <Testimonial />
                    <FeaturesSection />
                    <FaqSection />
                    <CtaSection /> 
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default HomePage;